<template>
  <!-- 

  [ 레이아웃 옵션 / default : vertical ]
  .horizontal : 가로정렬 레이아웃
  .vertical : 세로정렬 레이아웃


  [ 드롭다운 옵션 / defauly : hidden ]
  .dropdown
  .dropdown--full
  .dropdown--modal
  .dropdown--left


  [ 아코디언 옵션 / defauly : hidden ]
  .accordion


  [ 간격 옵션 / defauly : spacing--sm ]
  .spacing--sm
  .spacing--md
  .spacing--lg


  [ 폰트크기 옵션 / default : font--md ]
  .font--xs
  .font--sm
  .font--md
  .font--lg
  .font--xl


  [ 폰트두께 옵션 / default : font--400 ]
  .font--100
  .font--200
  .font--300
  .font--400
  .font--500
  .font--600
  .font--700
  .font--800
  .font--900  


  [ 보더옵션 / default : 없음 ]
  .border--solid
  .border--dashed


  [ 색상 테마 옵션 / default : theme--black ]
  .theme--black : 메뉴 폰트, 아이콘 검정
  .theme--white : 메뉴 폰트, 아이콘 흰색


  [ 호버 옵션 / default : 없음 ]
  .hover--bg
  .hover--opacity

  -->

  <nav class="menu-lg__container OPTION">
    <ul class="menu-main">
      <!-- is-selected 추가시 서브메뉴 펼처짐 -->
      <li
        class="menu-lg__item"
        v-for="menu in menus"
        :class="selected !== null && menu.menuName === selected.menuName ? 'is-selected' : ''"
        :key="menu.menuName"
      >
        <a
          class="menu-lg"
          @click="click(menu)"
        >
          <span class="menu-lg__label">{{menu.menuName}}</span>
          <i
            class="material-icons menu-lg__dropdown-icon"
            v-if="menu.children && menu.children.length > 0"
          >arrow_drop_down</i>
        </a>
        <menu-md
          :parent="menu"
          :menus="menu.children || []"
          @matchedRoute="matched"
          :menuClick="menuClick"
        ></menu-md>
      </li>
      <!-- <li class="menu-lg__item is-selected">
        <a
          href="#"
          class="menu-lg"
        >
          <span class="menu-lg__label">모든 크리에이티브</span>
          <i class="material-icons menu-lg__dropdown-icon">arrow_drop_down</i>
        </a>
        <menu-md></menu-md>
      </li>
      <li class="menu-lg__item">
        <a
          href="#"
          class="menu-lg"
        >
          <span class="menu-lg__label">대메뉴</span>
          <i class="material-icons menu-lg__dropdown-icon">arrow_drop_down</i>
        </a>
      </li> -->
    </ul>
  </nav>
</template>

<script>

export default {
  props: {
    menus: { type: Array },
    menuClick: { type: Function }
  },
  data () {
    return {
      selected: null
    }
  },
  methods: {
    matched ({ parent, menu }) {
      const match = this.menus.filter(menu => {
        return menu.menuName === parent.menuName
      })
      if (match.length > 0) {
        this.selected = match[0]
      }
      console.log('eeeeeeeee', menu, match)
    },
    click (menu) {
      // console.log('menu.meta.route', menu.route)
      if (menu.route && menu.route.name) {
        this.$router.push(menu.route)
      } else {
        // console.log(menu)
        // this.$router.push({ name: 'adminBoardList', param: { boardId: menu.boardId } })
        if (this.selected !== menu) {
          this.selected = menu
        } else {
          this.selected = null
        }
        this.$emit('selected', menu)
      }
    }
  },
  components: {
    MenuMd: () => import('@/component/layout/header/common/MenuMd')
  }
}
</script>
